if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }

    connectedCallback() {
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.openDefault = this.dataset.openDefault === 'true';

      // The classic footer collapses below 1024px; a footer-blocks column (`data-collapse-below="mobile"`) below 768px.
      const collapseOnMobile = this.dataset.collapseBelow === 'mobile';
      const isCollapsible = () => (collapseOnMobile ? FoxTheme.config.mqlMobile : FoxTheme.config.mqlTablet);
      const [matchEvent, unmatchEvent] = collapseOnMobile ? ['matchMobile', 'unmatchMobile'] : ['matchTablet', 'unmatchTablet'];

      // An always-open footer-blocks column heading does nothing, so it leaves the tab order until it can collapse.
      const syncTabStop = () => {
        if (!collapseOnMobile) return;
        if (isCollapsible()) {
          this.summaryElement.removeAttribute('tabindex');
        } else {
          this.summaryElement.setAttribute('tabindex', '-1');
        }
      };

      if (isCollapsible()) {
        if (!this.openDefault) this.toggle(false);
      }
      syncTabStop();

      document.addEventListener(matchEvent, () => {
        this.toggle(this.openDefault);
        syncTabStop();
      }, { signal });

      document.addEventListener(unmatchEvent, () => {
        this.toggle(true);
        syncTabStop();
      }, { signal });

      // A footer-blocks column carries the editor attributes, so its select / deselect (and a child block's
      // select, which bubbles) reach the column, not the details.
      const column = this.closest('[data-footer-column]');
      if (Shopify.designMode && column) {
        column.addEventListener('shopify:block:select', () => {
          this.open = true;
        }, { signal });

        column.addEventListener('shopify:block:deselect', (event) => {
          if (event.target !== column || !isCollapsible() || this.openDefault) return;
          this.open = false;
        }, { signal });
      }
    }

    // `pointer-events: none` on the summary keeps the mouse out of an always-open column, not the keyboard:
    // Enter / Space on the summary still click it. A footer-blocks column ignores that click while it is not collapsible.
    toggleAccordion(event) {
      if (this.dataset.collapseBelow === 'mobile' && !FoxTheme.config.mqlMobile) {
        event.preventDefault();
        return;
      }
      super.toggleAccordion(event);
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}
